import React, { Suspense, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { useAuth } from "../../context/AuthContext";
import { getHubProfiles, getHubDisplayName } from "../Subscription/SubscriptionHelpers";
import { FOOTER } from "../../config/zinihubConfig";
import { Breadcrumb } from "../../components/Breadcrumb";
import styles from "./HubSettings.module.css";
import PageContainer from "../../components/PageContainer/PageContainer";

const BusinessDocsPanel = React.lazy(() => import("./BusinessDocsPanel"));

const HubSettings = () => {
  const { token, decodeToken } = useAuth();
  const navigate = useNavigate();

  const decodedToken = useMemo(() => decodeToken(token), [token, decodeToken]);
  const hubProfiles = useMemo(() => getHubProfiles(decodedToken), [decodedToken]);
  const firstHub = hubProfiles[0] || null;

  const hubName = firstHub ? getHubDisplayName(firstHub) : "";
  const hubDomain = firstHub?.Domain ? `${firstHub.Domain}.${FOOTER.CUSTOMER}` : "";

  if (!decodedToken) {
    return (
      <div className={styles.loadingWrap}>
        <Spin size="large" />
        <p className={styles.loadingText}>Loading...</p>
      </div>
    );
  }

  return (
    <PageContainer>
      <Breadcrumb items={[
        { label: 'Hub Settings' }
      ]} />
      <div className={styles.pageTitle}>Hub Settings</div>

      <div className={styles.kycCard}>
        <div className={styles.kycHeader}>
          <div className={styles.kycIcon}>{"\ud83d\udd10"}</div>
          <div className={styles.kycTitle}>KYC Verification</div>
          <span className={styles.kycBadge}>Not Verified</span>
        </div>
        <div className={styles.kycDesc}>
          Complete KYC to unlock <strong>{"\ud83d\udcb3"} Gateway payment</strong> for your stores. Customers can pay online directly.
        </div>
        <div className={styles.kycChips}>
          <span className={styles.kycChip}>{"\u2713"} Gateway payments</span>
          <span className={styles.kycChip}>{"\u2713"} Trust badge on storefront</span>
          <span className={styles.kycChip}>{"\u2713"} Higher customer confidence</span>
        </div>
        <div className={styles.kycBtn} onClick={() => navigate("/hubSettings/kyc")}>
          Start KYC Verification &rarr;
        </div>
      </div>

      <div className={styles.settingsCard}>
        <div className={styles.settingsHeader}>General Settings</div>
        <div className={styles.fieldRow}>
          <div className={styles.fieldLabel}>Hub Display Name</div>
          <div className={styles.fieldBox}>
            <span className={styles.fieldVal}>{hubName || "—"}</span>
          </div>
        </div>
        <div className={styles.fieldRow}>
          <div className={styles.fieldLabel}>Domain</div>
          <div className={styles.fieldBox}>
            <span className={styles.fieldVal}>{hubDomain || "—"}</span>
          </div>
          {firstHub?.Domain && <div className={styles.fieldHint}>Read-only after creation</div>}
        </div>
      </div>

      {firstHub?.PK && (
        <Suspense fallback={<Spin size="small" />}>
          <BusinessDocsPanel token={token} hubId={firstHub.PK} />
        </Suspense>
      )}
    </PageContainer>
  );
};

export default HubSettings;
